export const playShutUp = (player) => {
  player.play();
};

export const addPlayerLifecycle = (player, onEnd) => {
  player.addEventListener("ended", onEnd);
};
